import { FC } from "react";
import styled from "styled-components";
import { EventAnalyticsResource } from "./analyticsTypes";
import { OverviewCard } from "./OverviewCard";
import { LowPerformerCard, TopPerformerCard } from "./PerformerCard";

interface Props {
	data: EventAnalyticsResource;
}

const Wrapper = styled.div`
	display: grid;
	gap: ${({ theme }) => theme.spacing(2)};
	grid-template-columns: 1fr 1fr 1fr;
`;

export const Summary: FC<Props> = ({ data }) => {
	return (
		<Wrapper>
			<OverviewCard overview={data.overview} />
			<TopPerformerCard events={data.topPerformerEvents} />
			<LowPerformerCard events={data.lowPerformerEvents} />
		</Wrapper>
	);
};
